"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListActions = exports.ActionsController = exports.createAction = void 0;
var app_1 = require("app");
var createAction = function (type, data) { return ({
    data: data,
    type: type,
    uuid: app_1.UtilService.newUUID(),
}); };
exports.createAction = createAction;
var ActionsController_1 = require("./ActionsController");
Object.defineProperty(exports, "ActionsController", { enumerable: true, get: function () { return ActionsController_1.ActionsController; } });
var FilterableListActions_1 = require("./FilterableListActions");
Object.defineProperty(exports, "FilterableListActions", { enumerable: true, get: function () { return FilterableListActions_1.FilterableListActions; } });
